import {gsap, ScrollTrigger, CustomEase} from "gsap/all";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CustomEase)
gsap.config({nullTargetWarn: false});

class productHeroSliderInit {
    constructor() {
        this.target = document.querySelector('.section-product-hero-slider');
        this.items = this.target && gsap.utils.toArray('.side-content-wrap .side-content-item');
        this.target && this.items && this.init();
    }

    init() {
        this.mainAnimations();
    }

    debounce(func, delay) {
        let timer;
        return (args) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    }

    updateScrollTrigger() {
        ScrollTrigger.refresh();
    }

    mainAnimations() {
        ScrollTrigger.config({ ignoreMobileResize: true });
        const sectionTop = this.target.querySelector('.section-top');
        const sectionBottom = this.target.querySelector('.section-bottom');
        const sectionWrap = this.target.querySelector('.side-content-wrap');
        const sectionSlider = this.target.querySelector('.product-hero-slider--wrap');
        const sectionBottomItems = gsap.utils.toArray('.section-bottom__item');

        sectionBottomItems.forEach((item, index) => gsap.set(item, {y: `${56 * (index + 1)}px`}));

        window.addEventListener('resize', this.debounce(this.updateScrollTrigger, 1500));

        let mm = gsap.matchMedia();
        mm.add("(min-width: 1024px)", () => {
            this.items.length > 1 && gsap.timeline({
                scrollTrigger: {
                    trigger: sectionTop,
                    start: "top top",
                    end: 'bottom bottom',
                    toggleActions: "play none none reverse",
                    scrub: true,
                },
            }).fromTo(this.items[0], { opacity: 1, zIndex: 1 }, { opacity: 0, zIndex: 0 }, '<')
            .fromTo(this.items[1], { opacity: 0.25, zIndex: 0 }, { opacity: 1, zIndex: 1 }, '<');

            gsap.timeline({
                scrollTrigger: {
                    trigger: sectionTop,
                    start: "top top",
                    end: sectionBottomItems.length > 0 ? "top top" : "top bottom",
                    endTrigger: sectionBottom,
                    toggleActions: "play none none reverse",
                    pin: sectionSlider,
                    pinSpacing: false,
                },
            });

            gsap.timeline({
                scrollTrigger: {
                    trigger: sectionTop,
                    start: "bottom bottom",
                    end: sectionBottomItems.length > 0 ? "top top" : "top bottom",
                    endTrigger: sectionBottom,
                    toggleActions: "play none none reverse",
                    pin: sectionWrap,
                    pinSpacing: false,
                },
            });

            sectionBottomItems.length > 0 && gsap.timeline({
                scrollTrigger: {
                    trigger: sectionBottom,
                    start: "top bottom",
                    end: "top top",
                    toggleActions: "play none none reverse",
                    pin: true,
                    pinSpacing: false,
                },
            }).to(sectionWrap, { opacity: 0, duration: 0.6 })
            .to(sectionSlider, { opacity: 0.1, duration: 0.6 }, '<')
            .to(sectionSlider, { filter: "blur(30px)", duration: 0.3 }, "-=0.3")
            .to(sectionBottom, { yPercent: -100 , duration: 0.6, ease: CustomEase.create("", "0.4, 1, 1, 1"), }, '-=0.5')
            .to(sectionBottomItems, { y: 0, duration: 0.4, stagger: 0.1 }, '<');
        });
    }
}

export default productHeroSliderInit;
